<div class="component-main-container">
  <!-- Cabeçalho -->
  <div class="header">
    <app-page-header parentTitle="{{'gateways.parentTitle' | translate}}"
      pageTitle="{{'gateways.pageTitle' | translate}}"></app-page-header>
  </div>
  <div class="row">
    <div class="col-lg-5 col-xl-4 col-sm-12">
      <div class="component-forms-box">
        <!-- Box do formulário de registros -->
        <app-register-form></app-register-form>

        <!-- Box de filtro de concentradores -->
        <div class="form-fields-box" [formGroup]="filterForm" [ngClass]="!filterBox ? 'closed' : ''">
          <h2 (click)="filterBoxOpen()">{{'gateways.filter-form' | translate}} </h2>
          <hr [ngClass]="!filterBox ? 'hr-open' : ''">

          <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center">

            <mat-tab label="{{'gateways.mat-tab-reference' | translate}}">
              <br>
              <!-- Campo do formulário de referência -->
              <div class="form-step">
                <div class="circle-number"> 1 </div>
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.filter-form-reference' | translate}} </mat-label>
                  <input matInput formControlName="reference" #referenceFilter>
                </mat-form-field>
              </div>
              <!-- Botão do filtro -->
              <div class="d-flex m-2">
                @if (!filterLoading) {
                <button class="btn btn-success m-1 w-100" (click)="filterGateways(null)">
                  {{'gateways.button-filter' | translate}}
                </button>
                }
                @if (filterLoading) {
                <mat-spinner [diameter]="30"></mat-spinner>
                }
              </div>
            </mat-tab>

            <!-- Campo do formulário (filtro de equipamento) -->
            <mat-tab label="{{'gateways.mat-tab-equipmentType' | translate}}">
              <br>
              <!-- Campo para realizar a busca dos equipamentos -->
              <div class="form-step">
                <div class="circle-number"> 2 </div>
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.search-equipmentType-filter-form' | translate}} </mat-label>
                  <input matInput formControlName="equipment" #equipmentSerialNumberFilter>
                  <mat-icon class="component-search-icon"
                    (click)="searchEquipmentsFilter(equipmentSerialNumberFilter.value)" svgIcon="bx-search"></mat-icon>
                </mat-form-field>
              </div>

              <!-- Loading -->
              @if (equipmentLoadingFilter) {
              <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
              }

              <!-- Lista dos equipamentos filtrados -->
              @if (equipmentListFilter.length > 0 ) {
              <div class="form-step">
                <div class="circle-number-ready"> 2.1 </div>
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.select-equipmentType-filter-form' | translate}} </mat-label>
                  <mat-select formControlName="equipmentSelected" #value>
                    @for (equipment of equipmentListFilter; track equipment) {
                    <mat-option appereance="outline" [value]="equipment.id">
                      <strong> SN: </strong>
                      {{equipment.serialNumber}}
                      <strong>
                        ({{equipment.reference}}
                        {{equipment.major}}.{{equipment.minor}}.{{equipment.revision}})
                      </strong>
                    </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </div>
              }

              <!-- Botão de filtro -->
              <div class="d-flex m-2">
                @if (!filterLoading) {
                <button class="btn btn-success m-1 w-50" (click)="filterGateways(null)">
                  {{'gateways.button-filter' | translate}}
                </button>
                }

                <!-- Botão para limpar os campos do formulário -->
                @if (!filterLoading) {
                <button (click)="clearFilterForm()" class="btn btn-secondary m-1 w-50">
                  {{'gateways.button-clean-filter' | translate}}
                </button>
                }
                @if (filterLoading) {
                <mat-spinner [diameter]="30"></mat-spinner>
                }
              </div>
            </mat-tab>

            <!-- Campos do formulário de local de instalação -->
            <mat-tab label="{{'gateways.mat-tab-installation-site' | translate}}">
              <br>
              <!-- Campo de busca de um local de instalação -->
              <div class="form-step">
                <div class="circle-number"> 3 </div>
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.filter-form-adress' | translate}} </mat-label>
                  <input matInput matInput [formControl]="fullAddress" [placeholder]="filterPlaceholder" #filter>
                  <mat-icon class="component-search-icon" svgIcon="bx-search"></mat-icon>
                </mat-form-field>
              </div>
              <!-- Campos que serão automaticamente preenchidos com as informações do local de instalação
                    que foram filtradas -->
              <div class="form-step">
                <mat-form-field appearance="outline">
                  <mat-label> CEP </mat-label>
                  <input matInput mask="00000-000" [(ngModel)]="filterPostalCode" disabled=""
                    [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>

              <div class="form-step">
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.filter-form-public-place' | translate}} </mat-label>
                  <input matInput [(ngModel)]="filterPublicPlace" disabled="" #street
                    [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>

              <div class="form-step">
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.filter-form-city' | translate}} </mat-label>
                  <input matInput [(ngModel)]="filterCity" disabled="" #city [ngModelOptions]="{standalone: true}">
                </mat-form-field>

                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.filter-form-district' | translate}} </mat-label>
                  <input matInput [(ngModel)]="filterDistrict" disabled="" #district
                    [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>

              <div class="form-step">
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.filter-form-state' | translate}} </mat-label>
                  <input matInput [(ngModel)]="filterState" disabled="" #state [ngModelOptions]="{standalone: true}">
                </mat-form-field>
                <mat-form-field appearance="outline">
                  <mat-label> {{'gateways.filter-form-country' | translate}} </mat-label>
                  <input matInput [(ngModel)]="filterCountry" disabled="" #country
                    [ngModelOptions]="{standalone: true}">
                </mat-form-field>
              </div>

              <!-- Botão do filtro  -->
              <div class="d-flex m-2">
                @if (!filterLoading) {
                <button class="btn btn-success m-1 w-50" (click)="filterGateways(null)">
                  {{'gateways.button-filter' | translate}}
                </button>
                }
                <!-- Botão para limpar os campos do formulário -->
                @if (!filterLoading) {
                <button (click)="clearFilterForm()" class="btn btn-secondary m-1 w-50">
                  {{'gateways.button-clean-filter' | translate}}
                </button>
                }
                @if (filterLoading) {
                <mat-spinner [diameter]="30"></mat-spinner>
                }
              </div>
            </mat-tab>
          </mat-tab-group>
        </div>

        <!-- Box de registro de concentradores -->
        <div class="form-fields-box" [ngClass]="!registerBox ? 'closed' : ''">
          <h2 (click)="registerBoxOpen()"> {{'gateways.register-form' | translate}} </h2>
          <hr [ngClass]="!registerBox ? 'hr-open' : ''">

          <!-- Campo do formulário (referência) -->
          <div class="form-step">
            <div class="circle-number"> 1 </div>
            <div class="input-text">
              <p-floatlabel variant="on">
                <input pInputText fluid [formControl]="reference" id="reference" [pKeyFilter]="blockSpecialCharacters"
                  [class.p-invalid]="reference.invalid && reference.touched" />
                <label for="reference"> {{'gateways.register-form-reference' | translate}}</label>
              </p-floatlabel>
              @if (
              reference?.hasError('pattern') &&
              reference?.touched
              ) {
              <small class="p-error" style="color: red;">
                {{'installations.special-character-error' | translate}}
              </small>
              }
            </div>
          </div>

          <!-- Campo para realizar a busca dos equipamentos -->
          @if (validateStep1Create()) {
          <div class="form-step">
            <div class="circle-number"> 2 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{'gateways.search-equipment-register-form' | translate}} </mat-label>
              <input matInput [formControl]="equipment" #serialNumberEquipmentCreate>
              <mat-icon class="component-search-icon"
                (click)="searchEquipmentsCreate(serialNumberEquipmentCreate.value)" svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }

          <!-- Loading -->
          @if (equipmentLoadingCreate) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          <!-- Lista dos equipamentos filtrados -->
          @if (equipmentListCreate.length > 0) {
          <div class="form-step">
            <div class="circle-number-ready"> 2.1 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{'gateways.select-equipment-register-form' | translate}} </mat-label>
              <mat-select [formControl]="equipmentSelected">
                @for (equipment of equipmentListCreate; track equipment) {
                <mat-option appereance="outline" [value]="equipment.id">
                  <strong> SN: </strong>
                  {{equipment.serialNumber}}
                  <strong>
                    ({{equipment.reference}}
                    {{equipment.major}}.{{equipment.minor}}.{{equipment.revision}})
                  </strong>
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Campo para realizar a busca do local de instalação -->
          @if (validateStep2Create()) {
          <div class="form-step">
            <div class="circle-number"> 3 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{'gateways.search-installation-site-register-form' | translate}} </mat-label>
              <input matInput [formControl]="installationSite" #referenceSiteCreate>
              <mat-icon class="component-search-icon" (click)="searchInstallationSiteCreate(referenceSiteCreate.value)"
                svgIcon="bx-search"></mat-icon>
            </mat-form-field>
          </div>
          }
          <!-- Loading -->
          @if (installationSiteLoading) {
          <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
          }

          <!-- Campo com o local de instalação filtrado  -->
          @if (installationSiteListCreate.length > 0 ) {
          <div class="form-step">
            <div class="circle-number-ready"> 3.1 </div>
            <mat-form-field appearance="outline">
              <mat-label> {{'gateways.select-installation-site-register-form' | translate}}</mat-label>
              <mat-select [formControl]="installationSiteSelected">
                @for (site of installationSiteListCreate; track site) {
                <mat-option [value]="site.id">
                  <strong> {{site.reference}} </strong>
                  @if (site.street && site.number && site.city && site.state!= null) {
                  <span>({{site.street}}</span>
                  }
                  @if (site.street && site.number && site.city && site.state!= null) {
                  <span>,</span>
                  }
                  {{site.number}}
                  @if (site.street && site.number && site.city && site.state!= null) {
                  <span>-</span>
                  }
                  {{site.city}}
                  @if (site.street && site.number && site.city && site.state!= null) {
                  <span>/{{site.state}})</span>
                  }
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
          }

          <!-- Botão para realizar a criação do gateway -->
          @if (!createLoading) {
          <button class="btn btn-success" (click)="createGateway()"
            [disabled]="reference.invalid || equipmentSelected.invalid || installationSiteSelected.invalid">
            {{'gateways.button-save' | translate}}
          </button>
          }
          <!-- Loading -->
          @if (createLoading) {
          <mat-spinner [diameter]="30"></mat-spinner>
          }
        </div>
      </div>
    </div>

    <!-- Tabela de gateways -->
    @if (paginationProperties.total) {
    <div class="col-lg-8 col-xl-8 col-sm-12">
      @if (length > 0) {
      <app-table-header [itensNumber]="paginationProperties.count" [totalNumber]="paginationProperties.total"
        [hasCSV]="true" [hasPDF]="true" [loadingData$]="fileLoading" (downloadCSV)="generateFileData(null, 'CSV')"
        (downloadPDF)="generateFileData(null, 'PDF')">
      </app-table-header>
      }
      @if (ELEMENT_DATA.length) {
      <div class="table-container mt-2 mt-lg-3 mt-xl-3">
        <p-table [value]="ELEMENT_DATA" dataKey="id" [paginator]="true" [rows]="pageSize" [totalRecords]="length"
          (onPage)="pageChanged($event)" [showPageLinks]="false" [showFirstLastIcon]="false" [lazy]="true">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="reference"> {{'gateways.column-table-reference' | translate}}
              </th>
              <th pSortableColumn="installationSite" style="width:20%">{{'gateways.column-table-installation-site' |
                translate}}</th>
              <th pSortableColumn="equipmentType">{{'gateways.column-table-equipment-type' | translate}}</th>
              <th pSortableColumn="serialNumber"> {{'gateways.column-table-serial-number' | translate}}</th>
              <th pSortableColumn="status"> {{'gateways.column-table-status' | translate}}</th>
              <th pSortableColumn="actions"> {{'gateways.column-table-actions' | translate}}</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-row let-columns="columns" let-ri="rowIndex">
            <tr>
              <td> {{row.reference}}
              </td>
              <td> <strong>{{row.site.street}}</strong>@if (row.site.street && row.site.district && row.site.city &&
                row.site.number != null) {
                <span>,</span>
                }
                {{row.site.district}}@if (row.site.street && row.site.district && row.site.city && row.site.number !=
                null) {
                <span>,</span>
                }
                {{row.site.city}}
                @if (row.site.street && row.site.district && row.site.city && row.site.number != null) {
                <span>
                  -
                </span>
                }
                {{row.site.number}}
              </td>
              <td>
                <strong> {{row.device.reference}} </strong>
                @if (row.device.reference && row.device.major != null) {
                <span>
                  ({{row.device.major}}@if (row.device.reference && row.device.major != null) {
                  <span>.</span>
                  }
                  {{row.device.minor}}@if (row.device.reference && row.device.major != null) {
                  <span>.</span>
                  }
                  {{row.device.revision}})
                </span>
                }
              </td>
              <td> {{row.device.serialNumber}}</td>
              <td> @if (row.isActive === true ) {
                <span>{{'Ativo'}}</span>
                }
                @if (row.isActive === false) {
                <span>{{'Inativo'}}</span>
                }
              </td>
              <td>
                <!-- Botão de edição -->
                <p-button (click)="openSidebarUpdate(row, false)" styleClass="btn-actions" [rounded]="true"
                  icon="pi pi-pen-to-square" />
                <!-- Botão de Visualização -->
                <p-button (click)="openSidebarUpdate(row, true)" styleClass="btn-view" [rounded]="true"
                  icon="pi pi-eye" />
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      }
    </div>
    }
  </div>

  <!-- Sidebar de edição/visualização -->
  @if (editorController) {
  <div class="sidebar-edit" [formGroup]="updateForm">
    <mat-icon class="component-close-icon" (click)="closeSidebarUpdate()"> clear </mat-icon>
    @if (!viewController) {
    <h2> {{'gateways.sidebar-edit-title' | translate}} </h2>
    }
    @if (viewController) {
    <h2> {{'gateways.sidebar-view-title' | translate}} </h2>
    }
    <hr>
    <mat-form-field appearance="outline">
      <mat-label> {{'gateways.edit-form-reference' | translate}} </mat-label>
      <input matInput formControlName="reference">
    </mat-form-field>
    <!-- Campo para realizar a busca do(s) equipamento(s) -->
    <mat-form-field appearance="outline">
      <mat-label> {{'gateways.search-equipment-edit-form' | translate}} </mat-label>
      <input matInput formControlName="equipment" #equipmentSerialNumber>
      <mat-icon class="component-search-icon" (click)="searchEquipmentsUpdate(equipmentSerialNumber.value)"
        svgIcon="bx-search"></mat-icon>
    </mat-form-field>
    <!-- Loading -->
    @if (equipmentLoadingUpdate) {
    <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
    }
    <!-- Campo com o(s) equipamento(s) filtrado(s) -->
    @if (equipmentListUpdate.length > 0) {
    <mat-form-field appearance="outline">
      <mat-label> {{'gateways.select-equipment-edit-form' | translate}} </mat-label>
      <mat-select formControlName="equipmentSelected">
        @for (equipment of equipmentListUpdate; track equipment) {
        <mat-option appereance="outline" [value]="equipment.id">
          {{equipment.serialNumber}} ({{equipment.reference}}
          {{equipment.major}}.{{equipment.minor}}.{{equipment.revision}})
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    <!-- Campo para realizar a busca do local de instalação -->
    <mat-form-field appearance="outline">
      <mat-label> {{'gateways.search-installation-site-edit-form' | translate}} </mat-label>
      <input matInput formControlName="installationSite" #installationSiteReference>
      <mat-icon class="component-search-icon" (click)="searchInstallationSiteUpdate(installationSiteReference.value)"
        svgIcon="bx-search"></mat-icon>
    </mat-form-field>
    <!-- Loading -->
    @if (installationSiteLoadingUpdate) {
    <mat-progress-bar class="mb-2" mode="indeterminate"></mat-progress-bar>
    }
    <!-- Campo com o local de instalação filtrado -->
    @if (installationSiteListUpdate.length > 0) {
    <mat-form-field appearance="outline">
      <mat-label> {{'gateways.select-installation-site-edit-form' | translate}} </mat-label>
      <mat-select formControlName="installationSiteSelected">
        @for (site of installationSiteListUpdate; track site) {
        <mat-option appereance="outline" [value]="site.id">
          <strong> {{site.reference}} </strong>
          @if (site.street && site.number && site.city && site.state!= null) {
          <span>({{site.street}}</span>
          }
          @if (site.street && site.number && site.city && site.state!= null) {
          <span>,</span>
          }
          {{site.number}}
          @if (site.street && site.number && site.city && site.state!= null) {
          <span>-</span>
          }
          {{site.city}}
          @if (site.street && site.number && site.city && site.state!= null) {
          <span>/{{site.state}})</span>
          }
        </mat-option>
        }
      </mat-select>
    </mat-form-field>
    }
    <!-- Botão para salvar o gateway editado -->
    @if (!viewController) {
    <div class="d-flex m-2" id="buttons-edit">
      @if (!viewController && updateForm.value.isActive && !updateLoading) {
      <button class="btn btn-success m-1 w-50" (click)="updateGateway()" [disabled]="updateForm.invalid">
        {{'gateways.button-edit' | translate}}
      </button>
      }
      <!-- Botão para alterar o status do gateway inativado -->
      @if (updateForm.value.isActive && !viewController && !updateLoading) {
      <button class="btn btn-secondary m-1 w-50" (click)="updateStatusGateway(false)">
        {{'gateways.button-inactivate' | translate}}
      </button>
      }
      @if (updateLoading) {
      <mat-spinner [diameter]="30"></mat-spinner>
      }
    </div>
    }
    <!-- Botão para alterar o status do gateway ativado -->
    @if (!updateForm.value.isActive && !viewController) {
    <button class="btn btn-success" (click)="updateStatusGateway(true)" [disabled]="updateForm.invalid">
      {{'gateways.button-activate' | translate}}
    </button>
    }
  </div>
  }
</div>